import { NewActionMenu } from "@app/shared/action-menu";
import { ChangedGapsEnum } from "@app/projects/enumerators";
import { ReactElement, useContext, useEffect, useState } from "react";
import { ZipProjectContext } from "./ZipProjectContext";
import { FlyoutContext } from "@app/shared/Flyouts";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";

export const ZipChangedGapsFilter = (): ReactElement => {
  const projectContext = useContext(ZipProjectContext);
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);


  if (enabledFeatureFlags.has(Features.ZIP_ANALYSIS_CHANGED_GAPS)) {
    return (
      <div className="my-2 d-flex justify-content-end">
        <NewActionMenu
          buttonText={projectContext.state.adequacyFilters.changedGaps ? `Changed Gaps: ${projectContext.state.adequacyFilters.changedGaps}` : "Changed Gaps"}
          testId="zip-changed-gaps-filter__changed-gaps"
          buttonClassNames="qes-button-secondary"
          alignRight={true}
          disabled={!projectContext.state.isCompareMode}
        >
          <ZipChangedGapsFilterContent />
        </NewActionMenu>
      </div>
    );
  };

  return null;
}

const ZipChangedGapsFilterContent = () => {
  const projectContext = useContext(ZipProjectContext);
  const actionMenuContext = useContext(FlyoutContext);
  const [tempValue, setTempValue] = useState(projectContext.state.adequacyFilters.changedGaps);

  useEffect(() => {
    setTempValue(projectContext.state.adequacyFilters.changedGaps);
  }, [projectContext.state.adequacyFilters.changedGaps]);

  return (
    <div>
      <div className="px-3 py-2">
        <QESRadioButton
          label="All Changed Gaps"
          testId="zip-changed-gaps-filter__all-changed-gaps"
          name="zip-changed-gaps"
          checked={tempValue === ChangedGapsEnum.All}
          onChange={(e) => setTempValue(e.target.value as ChangedGapsEnum)}
          value={ChangedGapsEnum.All}
        />
        <QESRadioButton
          label="Opened Gaps"
          testId="zip-changed-gaps-filter__opened-gaps"
          name="zip-changed-gaps"
          checked={tempValue === ChangedGapsEnum.Opened}
          onChange={(e) => setTempValue(e.target.value as ChangedGapsEnum)}
          value={ChangedGapsEnum.Opened}
        />
        <QESRadioButton
          label="Closed Gaps"
          testId="zip-changed-gaps-filter__closed-gaps"
          name="zip-changed-gaps"
          checked={tempValue === ChangedGapsEnum.Closed}
          onChange={(e) => setTempValue(e.target.value as ChangedGapsEnum)}
          value={ChangedGapsEnum.Closed}
        />
      </div>
      <div style={{ borderTop: "1px solid #e5e5e5" }} className="pt-2 px-2 d-flex justify-content-between">
        <QESButton
          qesType="secondary"
          qesTestId="zip-changed-gaps-filter__remove-changed-gaps-filter"
          onClick={() => { setTempValue(null); projectContext.onChangeChangedGapsFilter(null); actionMenuContext.handleCloseFlyout(); actionMenuContext.triggerElement.current.focus(); }}
        >
          Remove
        </QESButton>
        <QESButton
          qesType="primary"
          qesTestId="zip-changed-gaps-filter__submit-changed-gaps"
          onClick={() => { projectContext.onChangeChangedGapsFilter(tempValue); actionMenuContext.handleCloseFlyout(); actionMenuContext.triggerElement.current.focus(); }}
          disabled={!tempValue}
        >
          Apply
        </QESButton>
      </div>
    </div>
  );
}